// extracted by mini-css-extract-plugin
export default {"label":"LabelWrap_label__PXLcx","text":"LabelWrap_text__aDf4x"};